import { Injectable } from '@angular/core';
import {DataService} from "../../../services/data.service";

@Injectable({
  providedIn: 'root',
})
export class AllDetailsService {
  constructor(private ds:DataService){}

  preserveClass(classList:string, strs:string[] | string){
    if(!Array.isArray(strs)) strs = [strs];
    let classes = classList.split(' ').filter(x => !!x.trim());
    classes = classes.filter(c => this.ds.valueIncludes(c, strs));
    return this.ds.arrayToString(classes,' ');
  }

  mergeClasses(...classList:string[]){
    let classesStr = '';

    classList.forEach(str => {
      classesStr = `${classesStr} ${str}`;
    });

    return classesStr;
  }

  getClassFromFieldString(s:string){
    let classList = s;
    if(!s) return s;
    if(!s.includes('(')) return classList = '';
    else if(!s.includes(')')) return classList = '';
    else return classList = s.substring(s.indexOf('(')+1,s.indexOf(')')).trim();
  }

  getIconClassFromFieldString(s:string){
    if(!s) return s;
    if(!s.includes('[')) return '';
    else if(!s.includes(']')) return '';
    else return s.substring(s.indexOf('[')+1,s.indexOf(']')).trim();
  }

  getIconFromFieldString(s:string){
    let icon = s;
    if(!s) return s;
    if(!s.includes('icon-') || !s.includes('(') || !s.includes(')')) return icon = '';
    s = s.replace('(',' ');
    s = s.replace(')',' ');
    return icon = s.substring(s.indexOf('icon-')+5,s.indexOf(' ',s.indexOf('icon-'))).trim();
  }

  getPropertyFromFieldString(s:string,prop){
    prop = prop+'-';
    if(!s) return s;
    if(!s.includes(prop) || !s.includes('(') || !s.includes(')')) return 0;
    s = s.replace('(',' ');
    s = s.replace(')',' ');
    return s.substring(s.indexOf(prop)+(prop).length,s.indexOf(' ',s.indexOf(prop))).trim();
  }

  getInnerVisibleFields(s:string){
    const fieldStrings = [];
    if(!s) return  [];
    if(!s.includes('{')) return  [];
    else if(!s.includes('}')) return [];

    else s.substring(s.indexOf('{')+1,s.indexOf('}')).trim().split(',')
    .forEach(x => fieldStrings.push(x.trim()));
    return fieldStrings;
  }

  checkIfHasTabularDisplay(s:string){
    const icon = s;
    if(!s) return s;
    if(s.includes('tabular')) return true;
    else return false;
  }

  getDefaultColSize(col_:string, fieldsClass:string){
    let col = 'medium';
    if(this.ds.valueIncludes(col_,['col-','large','medium','small','very-small'])) return col_;
    else if(!fieldsClass.includes('col-')) return col = 'medium';
    else if(fieldsClass?.includes('-12')) return col = 'large';
    else if(fieldsClass?.includes('-6')) return col = 'medium';
    else if(fieldsClass?.includes('-4')) return col = 'small';
    else if(fieldsClass?.includes('-3')) return col = 'very-small';
    return col;
  }


  getNameFromFieldString(s:string){
    if(!s) return s;
    s = s.split('{')[0];
    s = s.split('(')[0];

    if(s.includes('.') && !s.includes(' as ')) return s.split('.')?.pop()?.trim();

    // indexes
    const as = s.indexOf(' as ');
    // name must end before this char
    const end = s.indexOf('(');
    const col = s.indexOf('col-');

    if(as >= 0 && end >= 0 && col >=0) return s.substring(as+3,end > col ? col : end);
    if(as >= 0 && end >= 0 && !(col >=0)) return s.substring(as+3,end);
    if(as >= 0 && !(end >= 0) && col >=0) return s.substring(as+3,col);
    if(as >= 0 && !(end >= 0) && !(col >=0)) return s.substring(as+3,undefined);
    return s.split(' ')[0];
  }

  getKeyFromFieldString(s:string){
    let key = s;
    if(!s) return s;
    return key = s.split(' ')[0];
  }
}
